



























import { Component, Prop } from 'vue-property-decorator';
import Multiselect from 'vue-multiselect';
import Avatar from '@/components/common/Avatar.vue';
import { BaseMixin } from '@/mixins/BaseMixin';
import { mixins } from 'vue-class-component';
import { CheckIcon } from 'vue-feather-icons';
import { UserSpecialType } from 'admiral-core';
import { Util } from '@/utils/Util';

@Component({
  components: { Multiselect, Avatar, CheckIcon },
})
export default class UserSpecialTypeSelect extends mixins(BaseMixin) {
  @Prop()
  type!: UserSpecialType;
  @Prop({ required: false, type: Array })
  errors!: string[];
  options: UserSpecialType[] = [
    UserSpecialType.None,
    UserSpecialType.Kb,
    UserSpecialType.Office,
    UserSpecialType.Boss,
  ];

  updateType(type: UserSpecialType) {
    this.$emit('update-special-type', type);
    this.$emit('blur');
  }

  isSelected(type: UserSpecialType) {
    return this.type === type;
  }
  typeLabel(type: UserSpecialType) {
    return Util.formatUserSpecialType(type);
  }
}
